<template>
    <div
        id="appointment_form"
        ref="appointment_form"
        class="offcanvas offcanvas-right"
        v-click-outside="handleOutsideClick"
    >
        <button id="appointment_form_toggle" style="display: none"></button>
        <!--begin::Header-->
        <div
            class="offcanvas-header d-flex align-items-center justify-content-between pb-5"
        >
            <h4 class="font-weight-bold m-0">
                {{ title }}
            </h4>
            <a
                href="#"
                class=""
                id="appointment_form_close"
                @click="closeOffcanvas('appointment_form')"
            >
                <i class="ki ki-close icon-md"></i>
            </a>
        </div>
        <!--end::Header-->
        <!--begin::Content-->
        <perfect-scrollbar
            class="offcanvas-content mr-n5 scroll"
            style="max-height: 85vh; position: relative"
        >
            <div
                class="bb-form-group client-select"
                v-if="isRegularAppointmentForm"
            >
                <div v-show="!selectedClient">
                    <label v-if="currentUser.isInLawIndustry">{{
                        $t("appointmentForm.subjectInput.label")
                    }}</label>
                    <label v-else>{{
                        $t("appointmentForm.clientInput.label")
                    }}</label>
                </div>
                <BBSelect
                    v-if="!currentUser.isInLawIndustry"
                    :options="clientsAsOptions"
                    v-model="form.fields.clientId"
                    :search="true"
                    :placeholder="$t('appointmentForm.clientInput.placeholder')"
                    :searchPlaceholder="
                        $t('appointmentForm.clientInput.searchPlaceholder')
                    "
                    :noOptionsText="
                        $t('appointmentForm.clientInput.noResultsText')
                    "
                >
                    <template
                        v-if="selectedClient"
                        v-slot:toggle="{ removeSelected }"
                    >
                        <div
                            class="badge-option-container"
                            @click="
                                clientDetailsVisible = !clientDetailsVisible
                            "
                        >
                            <div class="badge-option">
                                <div class="bb-badge">
                                    {{ selectedClient.initials }}
                                </div>
                                <div class="badge-option-text">
                                    <span>{{ selectedClient.fullName }}</span>
                                    <small>{{ selectedClient.email }}</small>
                                </div>
                            </div>
                            <i :class="clientDetailsArrowClass"></i>
                        </div>
                        <div
                            class="selected-client-details"
                            v-show="clientDetailsVisible"
                        >
                            <div class="selected-client-actions">
                                <span
                                    class="text-success mr-4"
                                    @click="editClient(selectedClient)"
                                    v-if="
                                        $hasRole(acl.roles.owner) ||
                                        $hasPermission(
                                            acl.permissions.manageAccount
                                        )
                                    "
                                    >{{
                                        $t(
                                            "appointmentForm.clientInput.editBtn"
                                        )
                                    }}</span
                                >
                                <span
                                    class="text-danger"
                                    @click="removeSelected"
                                    >{{
                                        $t(
                                            "appointmentForm.clientInput.removeBtn"
                                        )
                                    }}</span
                                >
                            </div>
                            <div class="selected-client-info">
                                <h5>
                                    {{
                                        $t(
                                            "appointmentForm.clientInput.details.title"
                                        )
                                    }}
                                </h5>
                                <div class="bb-client-profile-info-item">
                                    <label>{{
                                        $t(
                                            "appointmentForm.clientInput.details.emailLabel"
                                        )
                                    }}</label>
                                    <span>{{ selectedClient.email }}</span>
                                </div>
                                <div class="bb-client-profile-info-item">
                                    <label>{{
                                        $t(
                                            "appointmentForm.clientInput.details.phoneLabel"
                                        )
                                    }}</label>
                                    <span>{{ selectedClient.phone }}</span>
                                </div>
                                <div class="bb-client-profile-info-item">
                                    <label>{{
                                        $t(
                                            "appointmentForm.clientInput.details.notesLabel"
                                        )
                                    }}</label>
                                    <span>{{ selectedClient.notes }}</span>
                                </div>
                            </div>
                            <AppointmentsList
                                :client="selectedClient"
                                :paginationDisabled="true"
                            />
                        </div>
                    </template>

                    <template v-slot:optionItem="{ option }">
                        <div class="badge-option-container">
                            <div class="badge-option">
                                <div class="bb-badge">
                                    {{ option.initials }}
                                </div>
                                <div class="badge-option-text">
                                    <span>{{ option.text }}</span>
                                    <small>{{ option.description }}</small>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:optionsFooter>
                        <div
                            @click="createClient"
                            v-if="
                                $hasRole(acl.roles.owner) ||
                                $hasPermission(acl.permissions.manageAccount)
                            "
                        >
                            <i class="fas fa-plus"></i>
                            <span>{{
                                $t("appointmentForm.clientInput.createBtn")
                            }}</span>
                        </div>
                    </template>
                </BBSelect>
                <div class="bb-invalid-feedback" v-show="form.errors.clientId">
                    {{ form.errors.clientId }}
                </div>
            </div>
            <div class="mobile-client-select" v-if="isRegularAppointmentForm">
                <div v-if="selectedClient">
                    <div
                        class="badge-option-container"
                        @click="clientDetailsVisible = !clientDetailsVisible"
                    >
                        <div class="badge-option">
                            <div class="bb-badge">
                                {{ selectedClient.initials }}
                            </div>
                            <div class="badge-option-text">
                                <span>{{ selectedClient.fullName }}</span>
                                <small>{{ selectedClient.email }}</small>
                            </div>
                        </div>
                        <i :class="clientDetailsArrowClass"></i>
                    </div>
                    <div
                        class="selected-client-details"
                        v-show="clientDetailsVisible"
                    >
                        <div class="selected-client-actions">
                            <span
                                class="text-success mr-4"
                                @click="editClient(selectedClient)"
                                v-if="
                                    $hasRole(acl.roles.owner) ||
                                    $hasPermission(
                                        acl.permissions.manageAccount
                                    )
                                "
                                >{{
                                    $t("appointmentForm.clientInput.editBtn")
                                }}</span
                            >
                            <span
                                class="text-danger"
                                @click="removeSelectedClient"
                                >{{
                                    $t("appointmentForm.clientInput.removeBtn")
                                }}</span
                            >
                        </div>
                        <div class="selected-client-info">
                            <h5>
                                {{
                                    $t(
                                        "appointmentForm.clientInput.details.title"
                                    )
                                }}
                            </h5>
                            <div class="bb-client-profile-info-item">
                                <label>{{
                                    $t(
                                        "appointmentForm.clientInput.details.emailLabel"
                                    )
                                }}</label>
                                <span>{{ selectedClient.email }}</span>
                            </div>
                            <div class="bb-client-profile-info-item">
                                <label>{{
                                    $t(
                                        "appointmentForm.clientInput.details.phoneLabel"
                                    )
                                }}</label>
                                <span>{{ selectedClient.phone }}</span>
                            </div>
                            <div class="bb-client-profile-info-item">
                                <label>{{
                                    $t(
                                        "appointmentForm.clientInput.details.notesLabel"
                                    )
                                }}</label>
                                <span>{{ selectedClient.notes }}</span>
                            </div>
                        </div>
                        <AppointmentsList
                            :client="selectedClient"
                            :paginationDisabled="true"
                        />
                    </div>
                </div>
                <div
                    v-if="!selectedClient"
                    class="mobile-client-select-btn"
                    @click="selectClient"
                >
                    <span>{{
                        $t("appointmentForm.clientInput.placeholder")
                    }}</span>
                    <i class="la la-angle-right"></i>
                </div>
            </div>
            <div v-if="isGroupAppointmentForm">
                <button
                    type="button"
                    class="multiple-client-select-btn"
                    @click="selectClients()"
                >
                    <span>{{ clientsInputBtnLabel }}</span>
                    <i class="la la-angle-right"></i>
                </button>
                <div class="bb-invalid-feedback" v-show="form.errors.clientIds">
                    {{ form.errors.clientIds }}
                </div>
            </div>
            <hr />
            <div class="bb-date-input-value-container" @click="selectDate">
                <span class="bb-date-input-value">{{
                    selectedDateString
                }}</span>
                <i class="la la-angle-right"></i>
            </div>
            <div class="bb-invalid-feedback" v-show="form.errors.date">
                {{ form.errors.date }}
            </div>
            <hr />
            <div class="bb-form-group service-select">
                <label>{{ $t("appointmentForm.serviceInput.label") }}</label>
                <BBSelect
                    :options="serviceOptions"
                    v-model="form.fields.serviceId"
                    :search="true"
                    :placeholder="
                        $t('appointmentForm.serviceInput.placeholder')
                    "
                    :searchPlaceholder="
                        $t('appointmentForm.serviceInput.searchPlaceholder')
                    "
                    class="service-select"
                    :noOptionsText="
                        $t('appointmentForm.serviceInput.noResultsText')
                    "
                >
                    <template
                        v-slot:optionGroupItem="{ option }"
                        style="padding: 10px 13px"
                    >
                        <div class="service-option-container">
                            <div class="service-option-text">
                                <span>{{ option.text }}</span>
                                <small>{{ option.description }}</small>
                            </div>
                            <span>{{ option.price }}</span>
                        </div>
                    </template>
                    <template v-slot:optionsFooter>
                        <div
                            @click="createService({ placeId: currentPlace.id })"
                            v-if="
                                $hasRole(acl.roles.owner) ||
                                $hasPermission(acl.permissions.manageAccount)
                            "
                        >
                            <i class="fas fa-plus"></i>
                            <span>{{
                                $t("appointmentForm.serviceInput.createBtn")
                            }}</span>
                        </div>
                    </template>
                </BBSelect>
                <div class="bb-invalid-feedback" v-show="form.errors.serviceId">
                    {{ form.errors.serviceId }}
                </div>
            </div>
            <div class="mobile-service-select">
                <div class="bb-form-group">
                    <label>{{
                        $t("appointmentForm.serviceInput.label")
                    }}</label>
                    <div
                        class="mobile-service-select-btn"
                        @click="selectService"
                    >
                        <span
                            class="mobile-service-placeholder"
                            v-if="!selectedService"
                            >{{
                                $t("appointmentForm.serviceInput.placeholder")
                            }}</span
                        >
                        <span
                            class="mobile-service-selected"
                            v-if="selectedService"
                            >{{ selectedService.name }}</span
                        >
                        <i class="la la-angle-right"></i>
                    </div>
                </div>
            </div>
            <div class="bb-form-group">
                <label>{{ $t("appointmentForm.staffInput.label") }}</label>
                <BBSelect
                    :options="staffOptions"
                    v-model="form.fields.calendarId"
                    :placeholder="$t('appointmentForm.staffInput.placeholder')"
                    :search="true"
                    :searchPlaceholder="
                        $t('appointmentForm.staffInput.searchPlaceholder')
                    "
                    :noOptionsText="
                        $t('appointmentForm.staffInput.noResultsText')
                    "
                >
                    <template v-slot:optionItem="{ option }">
                        <div class="badge-option-container">
                            <div class="badge-option">
                                <div
                                    class="bb-badge"
                                    :style="'background-color:' + option.color"
                                    style="flex: 0 0 auto"
                                >
                                    {{ option.initials }}
                                </div>
                                <div class="badge-option-text">
                                    <span>{{ option.text }}</span>
                                    <small>{{ option.description }}</small>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-slot:optionsFooter>
                        <div
                            @click="createCalendar"
                            v-if="
                                $hasRole(acl.roles.owner) ||
                                $hasPermission(acl.permissions.manageAccount) ||
                                $hasPermission(acl.permissions.managePlace)
                            "
                        >
                            <i class="fas fa-plus"></i>
                            <span>{{
                                $t("appointmentForm.staffInput.createBtn")
                            }}</span>
                        </div>
                    </template>
                </BBSelect>
                <div
                    class="bb-invalid-feedback"
                    v-show="form.errors.calendarId"
                >
                    {{ form.errors.calendarId }}
                </div>
            </div>
            <div class="d-flex justify-content-between pt-5">
                <div class="bb-form-group mr-2">
                    <label>{{
                        $t("appointmentForm.startTimeInput.label")
                    }}</label>
                    <BBSelect
                        :options="startTimeOptions"
                        :placeholder="
                            $t('appointmentForm.startTimeInput.placeholder')
                        "
                        v-model="form.fields.from"
                        :noOptionsText="noStartTimeOptionsText"
                    ></BBSelect>
                    <div class="bb-invalid-feedback" v-show="form.errors.from">
                        {{ form.errors.from }}
                    </div>
                </div>
                <div class="bb-form-group ml-2">
                    <label>{{ $t("appointmentForm.durationLabel") }}</label>
                    <div class="appointment-duration-value">
                        <span class="">{{ appointmentDuration }}</span>
                        <!-- <i class="la la-angle-down"></i> -->
                    </div>
                </div>
            </div>

            <!-- ─── Recurrence Section ─── -->
            <div class="recurrence-section">
                <div class="recurrence-toggle-row">
                    <label class="recurrence-toggle-label">
                        <span class="recurrence-toggle-switch">
                            <input
                                type="checkbox"
                                v-model="recurrence.isRecurring"
                            />
                            <span class="toggle-slider"></span>
                        </span>
                        <span class="recurrence-toggle-text">{{
                            $t("appointmentForm.recurrence.toggle")
                        }}</span>
                    </label>
                </div>

                <transition name="recurrence-expand">
                    <div
                        class="recurrence-fields"
                        v-if="recurrence.isRecurring"
                    >
                        <!-- Frequency: label above, interval number + weeks unit inline -->
                        <div class="bb-form-group">
                            <label class="recurrence-label">{{
                                $t("appointmentForm.recurrence.intervalLabel")
                            }}</label>
                            <div class="recurrence-frequency-row">
                                <input
                                    type="number"
                                    class="bb-input recurrence-interval-input"
                                    v-model.number="recurrence.repeatInterval"
                                    min="1"
                                    step="1"
                                    @input="onRepeatIntervalInput"
                                />
                                <span class="recurrence-unit-label">{{
                                    $t("appointmentForm.recurrence.units.weeks")
                                }}</span>
                            </div>
                            <div
                                class="bb-invalid-feedback"
                                v-show="recurrence.errors.repeatInterval"
                            >
                                {{ recurrence.errors.repeatInterval }}
                            </div>
                        </div>

                        <!-- End date -->
                        <div class="bb-form-group">
                            <label class="recurrence-label">{{
                                $t("appointmentForm.recurrence.endDateLabel")
                            }}</label>
                            <input
                                type="date"
                                class="bb-input recurrence-date-input"
                                v-model="recurrence.endDate"
                                :min="minEndDate"
                                @change="recurrence.errors.endDate = null"
                            />
                            <div
                                class="bb-invalid-feedback"
                                v-show="recurrence.errors.endDate"
                            >
                                {{ recurrence.errors.endDate }}
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
            <!-- ─── End Recurrence Section ─── -->

            <div class="bb-form-group">
                <label>{{ $t("appointmentForm.notesInput.label") }}</label>
                <b-form-textarea
                    :placeholder="$t('appointmentForm.notesInput.placeholder')"
                    rows="4"
                    class="bb-textarea"
                    v-model="form.fields.notes"
                ></b-form-textarea>
                <div class="bb-invalid-feedback" v-show="form.errors.notes">
                    {{ form.errors.notes }}
                </div>
            </div>
        </perfect-scrollbar>
        <!--end::Content-->
        <div class="offcanvas-footer">
            <button class="bb-btn btn-success" @click="submit()">
                {{ submitButtonText }}
            </button>
        </div>
        <ServiceFormModal ref="serviceFormModal" />
        <CalendarFormModal ref="calendarFormModal" />
        <ClientFormModal ref="clientFormModal" />
    </div>
</template>

<script>
import AppointmentFormLayout from "@/assets/js/layout/extended/appointment-form.js";
import {
    OPEN_ELEMENT,
    CLOSE_ELEMENT,
} from "@/core/services/store/offcanvas.module.js";
import BBSelect from "@/view/content/BBForm/BBSelect.vue";
import { GET_CLIENTS } from "@/core/services/store/clients.module.js";
import { GET_SERVICES } from "@/core/services/store/services.module.js";
import { mapGetters } from "vuex";
import AppointmentsList from "@/view/pages/components/Client/AppointmentsList.vue";
import moment from "moment";
import serviceCategoryMapper from "@/core/services/helpers/serviceCategoryMapper.js";
import staffMapper from "@/core/services/helpers/staffMapper.js";
//import clientFormMixin from "@/core/mixins/clientFormMixin.js";
import clientFormModalMixin from "@/core/mixins/clientFormModalMixin.js";
//import serviceFormMixin from "@/core/mixins/serviceFormMixin.js";
import serviceFormModalMixin from "@/core/mixins/serviceFormModalMixin.js";
//import calendarFormMixin from "@/core/mixins/calendarFormMixin.js";
import calendarFormModalMixin from "@/core/mixins/calendarFormModalMixin.js";
import appointmentForm from "@/core/services/forms/appointmentForm.js";
import formMixin from "@/core/mixins/formMixin.js";
import { SET_ALERT_MESSAGES } from "@/core/services/store/alert.module.js";
import { GET_PLACES } from "@/core/services/store/places.module.js";
import httpService from "@/core/services/http.service.js";
import { enableBodyScroll } from "body-scroll-lock";
import timeOptionsMapper from "@/core/services/helpers/timeOptionsMapper.js";
import i18nService from "@/core/services/i18n.service.js";
import ServiceFormModal from "@/view/layout/extras/modal/ServiceFormModal.vue";
import CalendarFormModal from "@/view/layout/extras/modal/CalendarFormModal.vue";
import ClientFormModal from "@/view/layout/extras/modal/ClientFormModal.vue";

export default {
    name: "AppointmentForm",
    components: {
        BBSelect,
        AppointmentsList,
        ServiceFormModal,
        CalendarFormModal,
        ClientFormModal,
    },
    mixins: [
        formMixin,
        clientFormModalMixin,
        serviceFormModalMixin,
        calendarFormModalMixin,
    ],
    data() {
        return {
            clientDetailsVisible: false,
            startTimeOptions: [],
            recurrence: {
                isRecurring: false,
                repeatInterval: 1,
                endDate: null,
                errors: {
                    repeatInterval: null,
                    endDate: null,
                },
            },
        };
    },
    beforeMount() {
        // Get form object from appointmentForm service
        this.form = JSON.parse(JSON.stringify(appointmentForm));
    },
    mounted() {
        // Init Appointment Form Panel
        AppointmentFormLayout.init(this.$refs["appointment_form"]);
        // Dispatch GET_CLIENTS store action to get clients from api
        this.$store.dispatch(GET_CLIENTS);
        // Dispatch GET_SERVICES store action to get services from api
        this.$store.dispatch(GET_SERVICES);
    },
    computed: {
        ...mapGetters(["clientsAsOptions", "currentPlace", "currentUser"]),

        title() {
            if (this.form.mode === "edit") {
                return this.isGroupAppointmentForm
                    ? this.$t("appointmentForm.editGroupTitle")
                    : this.$t("appointmentForm.editTitle");
            }
            return this.isGroupAppointmentForm
                ? this.$t("appointmentForm.createGroupTitle")
                : this.$t("appointmentForm.createTitle");
        },

        submitButtonText() {
            if (this.form.mode === "edit") {
                return this.$t("appointmentForm.editSubmitBtn");
            }
            return this.$t("appointmentForm.createSubmitBtn");
        },

        /**
         * Return selected client object
         * @return {Object|null}
         */
        selectedClient() {
            if (this.form.fields.clientId) {
                return this.$store.getters.getClient(this.form.fields.clientId);
            }
            return null;
        },

        selectedService() {
            if (this.form.fields && this.form.fields.serviceId) {
                let services = [];
                this.currentPlace.services.forEach((serviceCategory) => {
                    serviceCategory.services.forEach((service) => {
                        services.push(service);
                    });
                });
                return services.find(
                    (service) => service.id === this.form.fields.serviceId
                );
            }
            return null;
        },

        selectedStaff() {
            if (this.form.fields && this.form.fields.calendarId) {
                return this.currentPlace.staff.find(
                    (staffMember) =>
                        staffMember.calendar.id === this.form.fields.calendarId
                );
            }
            return null;
        },

        serviceOptions() {
            let servicesExists =
                this.currentPlace && this.currentPlace.services ? true : false;
            let services = servicesExists ? this.currentPlace.services : [];

            if (servicesExists) {
                if (this.isRegularAppointmentForm) {
                    services = this.currentPlace.services
                        .map(function (serviceCategory) {
                            let serviceCategoryCopy = JSON.parse(
                                JSON.stringify(serviceCategory)
                            );
                            serviceCategoryCopy.services =
                                serviceCategoryCopy.services.filter(function (
                                    service
                                ) {
                                    return service.isGroupService == false;
                                });
                            return serviceCategoryCopy.services.length > 0
                                ? serviceCategoryCopy
                                : null;
                        })
                        .filter(function (serviceCategory) {
                            return serviceCategory !== null;
                        });
                }

                if (this.isGroupAppointmentForm) {
                    services = this.currentPlace.services
                        .map(function (serviceCategory) {
                            let serviceCategoryCopy = JSON.parse(
                                JSON.stringify(serviceCategory)
                            );
                            serviceCategoryCopy.services =
                                serviceCategoryCopy.services.filter(function (
                                    service
                                ) {
                                    return service.isGroupService == true;
                                });
                            return serviceCategoryCopy.services.length > 0
                                ? serviceCategoryCopy
                                : null;
                        })
                        .filter(function (serviceCategory) {
                            return serviceCategory !== null;
                        });
                }
            }

            return serviceCategoryMapper.mapServiceCategoriesAsOptions(
                services
            );
        },

        staffOptions() {
            if (this.currentPlace && this.currentPlace.staff) {
                let staffMembers = this.currentPlace.staff;
                if (
                    this.$hasRole(this.acl.roles.staffMember) &&
                    this.$hasOnlyBasePermission()
                ) {
                    staffMembers = staffMembers.filter((staffMember) => {
                        if (staffMember.id == this.currentUser.id) {
                            return staffMember;
                        }
                    });
                }
                if (this.selectedService) {
                    return staffMapper.mapStaffAsOptions(
                        staffMembers.filter((staffMember) => {
                            if (
                                staffMember.servicesIds.includes(
                                    this.selectedService.id
                                )
                            ) {
                                return staffMember;
                            }
                        })
                    );
                }
                return staffMapper.mapStaffAsOptions(staffMembers);
            }
            return [];
        },

        /**
         * Return arrow class name for client details
         * @return {String}
         */
        clientDetailsArrowClass() {
            return this.clientDetailsVisible
                ? "la la-angle-up"
                : "la la-angle-down";
        },

        selectedDateString() {
            return this.form.fields.date
                ? moment(this.form.fields.date)
                      .locale(i18nService.getActiveLanguage())
                      .format("dddd, D MMMM YYYY")
                : this.$t("appointmentForm.noDateLabel");
        },

        appointmentDuration() {
            if (this.selectedService) {
                return this.selectedService.duration + " min";
            }
            return "";
        },

        noStartTimeOptionsText() {
            if (
                this.selectedStaff &&
                this.selectedService &&
                this.form.fields.date
            ) {
                return this.$t("appointmentForm.startTimeInput.noResultsText");
            }
            return "Please select date, service and staff to see available start time options";
        },

        isRegularAppointmentForm() {
            return this.form.fields.type === "REGULAR";
        },

        isGroupAppointmentForm() {
            return this.form.fields.type === "GROUP";
        },

        clientsInputBtnLabel() {
            let countString = this.selectedService
                ? `${this.form.fields.clientIds.length}/${this.selectedService.sameTimePeople}`
                : this.form.fields.clientIds.length;
            return `${this.$t(
                "appointmentForm.clientsInputBtn"
            )} (${countString})`;
        },

        /**
         * Minimum allowed end date (matches appointment date, or today)
         */
        minEndDate() {
            if (this.form.fields.date) {
                return moment(this.form.fields.date).format("YYYY-MM-DD");
            }
            return moment().format("YYYY-MM-DD");
        },

        /**
         * Validated recurrence payload — ready for backend emission on submit
         */
        recurrencePayload() {
            if (!this.recurrence.isRecurring) return null;
            return {
                repeatInterval: this.recurrence.repeatInterval,
                endDate: this.recurrence.endDate,
            };
        },
    },
    methods: {
        handleOutsideClick(event) {
            if (event.target.classList.contains("offcanvas-overlay")) {
                this.closeForm();
            }
        },

        closeOffcanvas(elementId) {
            this.$store.dispatch(CLOSE_ELEMENT, elementId);
            let targetElement = document.querySelector("#appointment_form");
            enableBodyScroll(targetElement);
        },

        openOffcanvas(elementId) {
            document.querySelector("#" + elementId + "_toggle").click();
            this.$store.dispatch(OPEN_ELEMENT, elementId);
        },

        closeForm() {
            document.querySelector("#appointment_form_close").click();
        },

        /**
         * Open DateInput element and add form key attribute to element
         * @return {void}
         */
        selectDate() {
            document
                .querySelector("#date_input")
                .setAttribute("form-key", "appointmentForm");
            this.openOffcanvas("date_input");
        },

        /**
         * Open MobileClientSelect element and add form key attribute to element
         * @return {void}
         */
        selectClient() {
            document
                .querySelector("#mobile_client_select")
                .setAttribute("form-key", "appointmentForm");
            this.openOffcanvas("mobile_client_select");
        },

        /**
         * Open MultipleCLientSelect element and add form key attribute to element
         * @return {void}
         */
        selectClients() {
            document
                .querySelector("#multiple_client_select")
                .setAttribute("form-key", "appointmentForm");
            this.openOffcanvas("multiple_client_select");
        },

        /**
         * Open MobileServiceSelect element and add form key attribute to element
         * @return {void}
         */
        selectService() {
            document
                .querySelector("#mobile_service_select")
                .setAttribute("form-key", "appointmentForm");
            this.openOffcanvas("mobile_service_select");
        },

        /**
         * Update startTimeOptions
         * @return {void}
         */
        updateStartTimeOptions() {
            let queryParams = {
                calendar_id: this.selectedStaff.calendar.id,
                service_id: this.selectedService.id,
                date: moment(this.form.fields.date).format("YYYY-MM-DD"),
                space: 5,
            };
            if (this.form.helpers.appointmentId) {
                queryParams.appointment_id = this.form.helpers.appointmentId;
            }
            httpService
                .get("/api/b2b/free-slots", { params: queryParams })
                .then((response) => {
                    this.startTimeOptions = [];
                    response.data.data.forEach((slot) => {
                        this.startTimeOptions.push({
                            text: slot.from.slice(0, -3),
                            value: slot.from.slice(0, -3),
                        });
                    });
                });
        },

        submit() {
            if (this.recurrence.isRecurring && !this.validateRecurrence()) {
                return;
            }

            // Merge recurrence data into form.fields so formHelper serialises it
            if (this.recurrence.isRecurring) {
                this.form.fields.isRecurring = true;
                this.form.fields.repeatInterval = this.recurrence.repeatInterval;
                this.form.fields.recurrenceEndDate = this.recurrence.endDate;
            } else {
                delete this.form.fields.isRecurring;
                delete this.form.fields.repeatInterval;
                delete this.form.fields.recurrenceEndDate;
            }

            this.submitForm()
                .then((response) => {
                    this.$store.dispatch(SET_ALERT_MESSAGES, {
                        successMessages: [response.data.message],
                        errorMessages: null,
                    });
                    this.closeForm();
                    this.$store.dispatch(GET_PLACES);
                })
                .catch((error) => {
                    this.$store.dispatch(SET_ALERT_MESSAGES, {
                        successMessages: null,
                        errorMessages: [error.response.data.message],
                    });
                });
        },

        /**
         * Remove selected client
         * @return {void}
         */
        removeSelectedClient() {
            this.form.fields.clientId = null;
        },

        /**
         * Clamp repeatInterval when a value is present; leave empty for validation
         */
        onRepeatIntervalInput() {
            this.recurrence.errors.repeatInterval = null;
            const val = this.recurrence.repeatInterval;
            if (val === "" || val === null || val === undefined || isNaN(val)) {
                return;
            }
            const floored = Math.floor(val);
            this.recurrence.repeatInterval = floored < 1 ? 1 : floored;
        },

        /**
         * Validate recurrence fields when recurring is enabled
         * @return {Boolean}
         */
        validateRecurrence() {
            let isValid = true;
            this.recurrence.errors.repeatInterval = null;
            this.recurrence.errors.endDate = null;

            const interval = this.recurrence.repeatInterval;
            if (
                interval === "" ||
                interval === null ||
                interval === undefined ||
                isNaN(interval) ||
                Number(interval) < 1
            ) {
                this.recurrence.errors.repeatInterval = this.$t(
                    "appointmentForm.recurrence.errors.repeatIntervalRequired"
                );
                isValid = false;
            }

            if (!this.recurrence.endDate) {
                this.recurrence.errors.endDate = this.$t(
                    "appointmentForm.recurrence.errors.endDateRequired"
                );
                isValid = false;
            } else if (
                this.form.fields.date &&
                moment(this.recurrence.endDate).isBefore(
                    moment(this.form.fields.date),
                    "day"
                )
            ) {
                this.recurrence.errors.endDate = this.$t(
                    "appointmentForm.recurrence.errors.endDateBeforeStart"
                );
                isValid = false;
            }

            return isValid;
        },
    },

    watch: {
        "recurrence.isRecurring"(isRecurring) {
            if (!isRecurring) {
                this.recurrence.errors.repeatInterval = null;
                this.recurrence.errors.endDate = null;
            }
        },

        /**
         * Watch for selectedStaff change
         */
        selectedStaff: {
            handler() {
                if (
                    this.selectedStaff &&
                    this.selectedService &&
                    this.form.fields.date
                ) {
                    this.updateStartTimeOptions();
                }
            },
        },
        /**
         * Watch for selectedService change
         */
        selectedService: {
            handler() {
                if (
                    this.selectedStaff &&
                    this.selectedService &&
                    this.form.fields.date
                ) {
                    this.updateStartTimeOptions();
                }
            },
        },
        /**
         * Watch for date field change
         */
        "form.fields.date": {
            handler(newDate) {
                if (this.currentPlace && newDate) {
                    this.startTimeOptions = timeOptionsMapper.mapTimeOptions(
                        moment(newDate),
                        this.currentPlace
                    );
                }

                if (this.selectedStaff && this.selectedService && newDate) {
                    this.updateStartTimeOptions();
                }
            },
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/sass/bb-styles/forms/appointment-form.scss";
</style>
